var urlRegex = new RegExp(/^https?:\/\//);
export function getFullUrl(path) {
  var hostConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    host: window.location.hostname,
    port: window.location.port
  };
  // always return a just the URL if one is provided
  if (urlRegex.test(path)) {
    return path;
  }
  return hostConfig.host === 'localhost' ? "http://".concat(hostConfig.host, ":").concat(hostConfig.port).concat(path) : path;
}